import { RootState } from '../store';

const selectIsFetching = (state: RootState) => state.auth.isFetching;
const selectIsAuthorized = (state: RootState) => !!state.auth.token;

export const authSelectors = {
  selectIsFetching,
  selectIsAuthorized,
};
